import { cn } from "@/lib/utils";

export type LogomarkSize = "sm" | "md" | "lg";

const sizeMap: Record<LogomarkSize, string> = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-11 w-11",
};

export function Logomark({ size = "md", className }: { size?: LogomarkSize; className?: string }) {
  return (
    <span
      role="img"
      aria-label="DevStackIO Tools"
      className={cn("inline-flex shrink-0", sizeMap[size], className)}
    >
      <svg
        viewBox="0 0 32 32"
        fill="none"
        aria-hidden="true"
        className="h-full w-full drop-shadow-[0_2px_6px_rgb(13_74_51/0.25)]"
      >
        <rect x="1.5" y="1.5" width="29" height="29" rx="9" fill="var(--color-accent)" />
        <rect x="1.5" y="1.5" width="29" height="29" rx="9" stroke="var(--color-signal)" strokeOpacity="0.55" strokeWidth="1.5" />
        <path
          d="M11 10.5 L8 16 L11 21.5"
          stroke="var(--color-accent-fg)"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21 10.5 L24 16 L21 21.5"
          stroke="var(--color-accent-fg)"
          strokeWidth={2.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect x="13.2" y="20.6" width="9.6" height="3.4" rx="1.7" transform="rotate(-12 13.2 20.6)" fill="var(--color-signal)" />
      </svg>
    </span>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "font-[family-name:var(--font-display)] text-[var(--color-text)] font-semibold tracking-[-0.015em]",
        className,
      )}
    >
      DevStack<span className="text-[var(--color-stamp)]">IO</span>
    </span>
  );
}
